import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type SiteSearchContextValue = {
  query: string;
  setQuery: (value: string) => void;
  clearQuery: () => void;
};

const SiteSearchContext = createContext<SiteSearchContextValue | null>(null);

export function SiteSearchProvider({ children }: { children: ReactNode }) {
  const [query, setQueryState] = useState('');
  const setQuery = useCallback((value: string) => {
    setQueryState(value);
  }, []);
  const clearQuery = useCallback(() => setQueryState(''), []);
  const value = useMemo(
    () => ({ query, setQuery, clearQuery }),
    [query, setQuery, clearQuery],
  );
  return (
    <SiteSearchContext.Provider value={value}>{children}</SiteSearchContext.Provider>
  );
}

export function useSiteSearch(): SiteSearchContextValue {
  const ctx = useContext(SiteSearchContext);
  if (!ctx) {
    throw new Error('useSiteSearch must be used within SiteSearchProvider');
  }
  return ctx;
}
